module.exports = "/images/circle-marker-car-1.png?395338a074bbed22f422614ffdfcfd44";